// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1J9LR","box":"WorkspacesBox_box__3WbOP","node":"WorkspacesBox_node__1xu38"};